import { render, staticRenderFns } from "./OwnNumberForm.vue?vue&type=template&id=68e24734&scoped=true"
import script from "./OwnNumberForm.vue?vue&type=script&lang=js"
export * from "./OwnNumberForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e24734",
  null
  
)

export default component.exports